import api from "./axios";

// Per-user preferences for the current user.

// Question Bank default filter: the user's most-recently-used subject (null = none yet).
export async function getLastUsedSubject() {
    const res = await api.get("/me/last-used-subject");
    return res.data; // { subjectId: number | null }
}

export async function setLastUsedSubject(subjectId) {
    const res = await api.patch("/me/last-used-subject", {subjectId: subjectId ?? null});
    return res.data;
}

// Permanently delete the current account (tenant) and ALL of its data. Owner-only (enforced
// server-side). Irreversible.
export async function deleteAccount() {
    const res = await api.delete("/me/account");
    return res.data;
}
